import {Link as RouterLink} from "react-router-dom";
import {Link} from "@mui/material";

function ContactTitle({data, contactId}) {
  const fullName = `${data.firstName ?? ''} ${data.lastName ?? ''}`.trim();
  const fallback = `Contact #${contactId}`;

  if (data.type === 'company') {
    return <>{data.firstName || fallback}</>;
  }

  const belongsToCompany = !!data.companyId && data.parentCompanyName;
  if (belongsToCompany) {
    return (
      <>
        <Link
          component={RouterLink}
          to={`/contacts/${data.companyId}`}
          underline="hover"
          color="primary"
        >
          {data.parentCompanyName}
        </Link>
        {`, ${fullName || fallback}`}
      </>
    );
  }

  return <>{fullName || fallback}</>;
}

export default ContactTitle;
